<template>
  <div class="center-item-body">
    <div class="common-mine-header-div">
      <span class="common-mine-time">时间</span>
      <span class="common-mine-title">购买商品</span>
      <span class="common-mine-span">消耗类型</span>
      <span class="common-mine-span">消耗数量</span>
      <span class="common-mine-span">交易状态</span>
    </div>
    <ul class="common-mine-ul">
      <li class="common-mine-li" v-for="(item,index) in shopList" :key="index">
        <span class="common-mine-time">{{new Date(item.shop_create_time).Format("yyyy-MM-dd hh:mm:ss")}}</span>
        <span class="common-mine-a-title" @click="enterShopDetails(item.shop_id)">{{item.shop_name}}</span>
        <span class="common-mine-span">{{item.shop_consume_type == 1 ? '积分' : '平台币'}}</span>
        <span class="common-mine-span">{{item.shop_consume_count}}</span>
        <span class="common-mine-span">{{handleState(item.shop_type,item.shop_state)}}</span>
      </li>
    </ul>
    <CommonPage v-if="isPageShow" class="center-game-page" style="margin: 20px auto;" :current.sync='commonPage' :page-size="commonRow"
      :total="commonTotal" show-total  show-elevator  @on-change="selectPage"
      prev-text="上一页" next-text="下一页"/>
  </div>
</template>
 
<script>
  import CommonPage from '../../components/CommonPage';
export default {
  data() {
    return {
      loginState:false,   
      shopList: [],
      commonTotal:0,
      commonPage:1,
      commonRow:15,
      isPageShow:false
    };
  },
  components:{ CommonPage },
  mounted(){
    if (window.sessionStorage.getItem("token") !== null) {
      this.loginState = true;
    }   
    this.queryMineShop();
  },
  methods:{
    queryMineShop(){
      this.$http.post('/query_web_mine_shop?page='+this.commonPage+"&row="+this.commonRow,{})
      .then(res =>{
        if(res.data.code == 2000){
          this.shopList = res.data.data;
          this.commonTotal = res.data.total;
          if(this.commonTotal > this.commonRow){
            this.isPageShow = true;
          }else{
            this.isPageShow = false;
          }
        }else{
          this.shopList = [];
          this.isPageShow = false;
        }
      })
    },
    handleState(type,state){
      if(type == 1){
        //礼包
        if(state == 1){
          return "兑换成功";
        }else{
          return "兑换失败";
        }
      }else{
        //实物
        if(state == 2){
          return "发货中";
        }else if(state == 1){
          return "兑换成功";
        }else{
          return "兑换失败";
        }
      }
    },
    selectPage(value) {
      this.commonPage = value;
      this.queryMineShop();
    },
    enterShopDetails(value){
      this.$router.push({name:'shopDetails',query:{sid:value}});
    }
  },
  watch:{
    loginState(value){
      if(value){
        this.queryMineShop();
      }
    }
  }
};
</script>
<style src="@/assets/css/mine_center.css" scoped></style>